<template>
  <tr
    :key="index"
    :style="{ cursor: 'pointer' }"
    :class="selectedRow == index ? 'indigo lighten-5' : ''"
    @click="selectRow(index)"
  >
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell promo-name">
      {{ item.promo_name }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell mid-bank">
      {{ item.mid_bank }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell merchant-name">
      {{ item.merchant_name }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell mpan">
      {{ item.mpan }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell rrn">
      {{ item.rrn }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell customer-pan">
      {{ item.customer_pan }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell customer-name">
      {{ item.customer_name }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell amount">
      {{ item.amount }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell discount">
      {{ item.discount }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell cashback">
      {{ item.cashback }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell trx-date">
      {{ item.trx_date }}
    </td>
  </tr>
</template>

<script>
export default {
  props: ['options', 'selectedRow', 'item', 'index'],
  computed: {},
  methods: {
    selectRow(index) {
      this.$emit('selectRowParent', index);
    },
  },
};
</script>
